import React, { useEffect, useState } from "react";

import moment from "moment";

import { DateRangePicker, isInclusivelyBeforeDay } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllGroups } from "store/Group/actions";
import { onDatesChange } from "store/Group/actions";

const DateRangePickerComp = (props) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focused, setFocused] = useState(null);
  const dispatch = useDispatch();
  // const courses = useSelector((state) => state.courses);
  const groups = useSelector((state) => state.groups);

  const handleDateChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
    dispatch(onDatesChange({ startDate, endDate }));
  };

  const onFocusChange = (focused) => {
    setFocused(focused);
  };

  useEffect(() => {
    dispatch(fetchAllGroups());
  }, []);

  useEffect(() => {
    if (props.startDate === null && props.endDate === null) {
      setStartDate(null);
      setEndDate(null);
    } else if (props.endDate === null) {
      setStartDate(props.startDate ? moment(props.startDate) : null);
      setEndDate(null);
    } else if (props.startDate === null) {
      setStartDate(null);
      setEndDate(props.endDate ? moment(props.endDate) : null);
    } else {
      setStartDate(props.startDate ? moment(props.startDate) : null);
      setEndDate(props.endDate ? moment(props.endDate) : null);
    }
  }, []);

  useEffect(() => {
    if (props.startDate === null && props.endDate === null) {
      setStartDate(null);
      setEndDate(null);
    } else if (props.endDate === null) {
      setStartDate(props.startDate ? moment(props.startDate) : null);
      setEndDate(null);
    } else if (props.startDate === null) {
      setStartDate(null);
      setEndDate(props.endDate ? moment(props.endDate) : null);
    } else {
      setStartDate(props.startDate ? moment(props.startDate) : null);
      setEndDate(props.endDate ? moment(props.endDate) : null);
    }
  }, [props]);
  return (
    <DateRangePicker
      numberOfMonths={1}
      startDate={startDate}
      startDateId="startDate"
      endDate={endDate}
      endDateId="endDate"
      focusedInput={focused}
      onDatesChange={handleDateChange}
      onFocusChange={onFocusChange}
      small
    />
  );
};
export default DateRangePickerComp;
